import './App.css';
import Home from 'pages/Home/Home.tsx';
import Intro from 'pages/Home/Intro.tsx';
import Venue from 'pages/Home/Venue.tsx';
import Accomodations from 'pages/Home/Accomodations.tsx';
import AboutUs from 'pages/Home/AboutUs.tsx';
import RSVP from 'pages/Home/RSVP.tsx';
import Details from 'pages/Home/Details.tsx';
import Rehearsal from 'pages/Home/Rehearsal.tsx';
import Registry from 'pages/Home/Registry.tsx';
import Honeyfund from 'pages/Home/Honeyfund.tsx';
import { default as TestHome } from 'pages/test/Home.tsx';
import { default as TestIntro } from 'pages/test/Home/Intro.tsx';

import NotFound from 'pages/404.tsx';

import { BrowserRouter, Routes, Route, Navigate } from "react-router";

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="honeyfund" element={<Honeyfund />} />
          <Route element={<Home />}>
            <Route index element={<Intro />} />
            <Route path="venue" element={<Venue />} />
            <Route path="hotels" element={<Accomodations />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="rsvp" element={<RSVP />} />
            <Route path="details" element={<Details />} />
            <Route path="rehearsal" element={<Rehearsal />} />
            <Route path="registry" element={<Registry />} />
            <Route path="honeyfund" element={<Honeyfund />} />
            <Route path="*" element={<Navigate to="https://love.tourt.one/404" replace />} />
          </Route>
          <Route element={<TestHome />} path="test">
            <Route index element={<TestIntro />} />
          </Route>
          <Route element={<NotFound />} path="/404"></Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
